/**
 * SUSI — <product-recommendations>
 *
 * Used by sections/related-products.liquid. The element starts empty; when it comes near the
 * viewport it requests its own section from the product recommendations endpoint (the URL is in
 * data-url) and adopts the markup that comes back. If Shopify has nothing to recommend the
 * element simply stays empty.
 *
 * Event: on:recommendations:load {count} (bubbles from the element) once products are in place.
 */
(() => {
  if (customElements.get('product-recommendations')) return;

  class ProductRecommendations extends HTMLElement {
    connectedCallback() {
      if (!this.dataset.url || this.childElementCount > 0) return;
      this.abortController = new AbortController();
      this.observer = window.theme.onVisible(this, () => this.load(), { rootMargin: '600px 0px' });
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      if (this.abortController) this.abortController.abort();
    }

    async load() {
      try {
        const page = await window.theme.fetchDocument(this.dataset.url, { signal: this.abortController.signal });
        const fresh = page.querySelector('product-recommendations');
        if (!fresh || !fresh.childElementCount) return;
        this.innerHTML = fresh.innerHTML;
        window.theme.emit('on:recommendations:load', { count: this.querySelectorAll('product-block').length }, this);
      } catch (error) {
        // Recommendations are a nice-to-have: on a failed request the section stays empty.
      }
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);
})();
